import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MapPin, Phone, MessageCircle } from "lucide-react";

const DEFAULT_SENDER = {
  name: "Rooftop Print",
  phone: "081314092016",
  address: "Jl. Pagarsih No.122, Cibadak, Kec. Astanaanyar, Kota Bandung, Jawa Barat 40241",
};

const waLink = (phone) => `https://wa.me/${(phone || "").replace(/[^0-9]/g, "").replace(/^0/, "62")}`;

export default function Footer() {
  const [sender, setSender] = useState(DEFAULT_SENDER);
  useEffect(() => { api.get("/settings/sender").then((r) => r.data && setSender(r.data)).catch(() => {}); }, []);

  return (
    <footer className="bg-[#00133F] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="https://customer-assets-0z36b82j.emergentagent.net/job_order-printing-id/artifacts/oyh0do4z_logo%20rooftop" alt="Rooftop Print" className="w-9 h-9 rounded-full object-cover" />
              <span className="font-heading font-extrabold text-lg">ROOFTOP <span className="text-[#F0005A]">PRINT</span></span>
            </div>
            <p className="text-slate-400 text-sm max-w-sm leading-relaxed">
              Percetakan kustom untuk mug, plakat akrilik & souvenir. Unggah desainmu, hitung ongkir otomatis,
              dan pesan dengan mudah. Melayani seluruh Indonesia.
            </p>
          </div>
          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">Alamat Toko</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2" data-testid="footer-address">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-[#F0005A]" />
                <span className="leading-relaxed">{sender.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 shrink-0 text-[#F0005A]" />
                <span>{sender.phone}</span>
              </li>
              <li>
                <a href={waLink(sender.phone)} target="_blank" rel="noopener noreferrer" data-testid="footer-wa-link"
                  className="inline-flex items-center gap-2 text-[#25D366] hover:brightness-110 transition-colors font-medium">
                  <MessageCircle className="w-4 h-4" /> Chat WhatsApp
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">Tautan</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/produk" className="hover:text-[#F0005A] transition-colors">Produk</Link></li>
              <li><Link to="/blog" className="hover:text-[#F0005A] transition-colors">Blog</Link></li>
              <li><Link to="/hubungi" data-testid="footer-contact-link" className="hover:text-[#F0005A] transition-colors">Hubungi Kami</Link></li>
              <li><Link to="/tentang" className="hover:text-[#F0005A] transition-colors">Tentang Kami</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {sender.name.toUpperCase()}. Dibuat untuk pasar Indonesia.</span>
          <Link to="/syarat" data-testid="footer-terms-link" className="text-slate-400 hover:text-[#F0005A] transition-colors">Syarat &amp; Ketentuan</Link>
        </div>
      </div>
    </footer>
  );
}
